import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/vercel/path0/src/templates/DocumentTemplate.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h4>{`Klarna Component`}</h4>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Error ID`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`session-not-created`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Session needs to be created before payment category can be collected.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`invalid-payment-category`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Payment category is invalid.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`payment-already-finalized`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`This payment was configured to finalize  automatically.`}</td>
        </tr>
      </tbody>
    </table>
    <h4>{`Banks Component`}</h4>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Error ID`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`banks-not-loaded`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Banks need to be loaded before bank id can be collected.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`invalid-bank-id`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Bank id doesn't belong to any of the supported banks.`}</td>
        </tr>
      </tbody>
    </table>
    <h4>{`Nol Pay Components`}</h4>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Error ID`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`invalid-otp-code`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`OTP code is not valid.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`invalid-phone-number`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Failed to parse phone number.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`invalid-card-number`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Card number cannot be blank.`}</td>
        </tr>
      </tbody>
    </table>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      